module.exports = __webpack_public_path__ + "media/images/career_camp/2022/intro_right_character-c734304e3739b485b74f0211ebde055a.svg";